import tonStyles from './../ton.json'

export default {
  color: tonStyles.colors.PrimaryBlack,
  borderColor: tonStyles.colors.SecondaryGrey,
  hover: {
    borderColor: tonStyles.colors.PrimaryBlack
  },
  active: {
    borderColor: tonStyles.colors.PrimaryBlack
  }
}
